(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edc-header"] && !Shopify.designMode) return;
  try {
    
  const edcMenuAnimations = new WeakMap();
  let edcHeaderScrolled;

  function updateEdcHeaderSurface() {
    const scrolled = window.scrollY > 8;
    if (scrolled === edcHeaderScrolled) return;
    edcHeaderScrolled = scrolled;
    document.querySelectorAll('.edc-header').forEach((header) => {
      header.dataset.scrolled = String(scrolled);
    });
  }

  window.addEventListener('scroll', updateEdcHeaderSurface, { passive: true });
  window.addEventListener('pageshow', updateEdcHeaderSurface);
  document.addEventListener('shopify:section:load', () => {
    edcHeaderScrolled = undefined;
    updateEdcHeaderSurface();
  });
  updateEdcHeaderSurface();

  function setEdcMenuExpanded(menu, expanded) {
    const summary = menu.querySelector('summary');
    const panel = menu.querySelector('.edc-header__drawer');
    const previous = edcMenuAnimations.get(menu);
    const style = getComputedStyle(panel);
    const start = menu.open
      ? { opacity: style.opacity, transform: style.transform }
      : { opacity: 0, transform: 'translateY(-4px)' };
    previous?.cancel();
    menu.dataset.expanded = String(expanded);
    summary.setAttribute('aria-expanded', String(expanded));
    panel.inert = !expanded;
    if (expanded) menu.open = true;

    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      menu.open = expanded;
      edcMenuAnimations.delete(menu);
      return;
    }

    const animation = panel.animate([
      start,
      expanded
        ? { opacity: 1, transform: 'translateY(0)' }
        : { opacity: 0, transform: 'translateY(-4px)' }
    ], { duration: expanded ? 160 : 110, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' });
    edcMenuAnimations.set(menu, animation);
    animation.onfinish = () => {
      if (edcMenuAnimations.get(menu) !== animation) return;
      if (!expanded) menu.open = false;
      animation.cancel();
      edcMenuAnimations.delete(menu);
    };
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.edc-header__menu-toggle');
    if (!summary) return;
    event.preventDefault();
    event.stopPropagation();
    const menu = summary.closest('.edc-header__mobile');
    setEdcMenuExpanded(menu, menu.dataset.expanded !== 'true');
  }, true);

  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll('.edc-header__mobile[data-expanded="true"]').forEach((menu) => {
      if (!menu.contains(event.target)) {
        if (menu.contains(document.activeElement)) menu.querySelector('summary').focus({ preventScroll: true });
        setEdcMenuExpanded(menu, false);
      }
    });
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.edc-header__mobile[open]').forEach((menu) => {
      event.stopPropagation();
      setEdcMenuExpanded(menu, false);
      menu.querySelector('summary').focus({ preventScroll: true });
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.reorderDrawerPrimaryLinks();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    reorderDrawerPrimaryLinks() {
      const drawerList = this.querySelector('#menu-drawer .menu-drawer__navigation > .menu-drawer__menu');
      if (!drawerList || drawerList.dataset.primarySorted === 'true') return;

      const topLevelItems = Array.from(drawerList.children);
      if (!topLevelItems.length) return;

      const groupedItems = [[], [], []];
      const otherItems = [];

      topLevelItems.forEach((item) => {
        const firstElement = item.firstElementChild;
        let labelNode = null;
        let hrefValue = '';

        if (firstElement) {
          if (firstElement.matches('a.menu-drawer__menu-item')) {
            labelNode = firstElement;
            hrefValue = firstElement.getAttribute('href') || '';
          } else if (firstElement.matches('details')) {
            labelNode = firstElement.querySelector('summary.menu-drawer__menu-item');
            const firstNestedLink = firstElement.querySelector('.menu-drawer__submenu a.menu-drawer__menu-item');
            hrefValue = firstNestedLink ? firstNestedLink.getAttribute('href') || '' : '';
          }
        }

        const normalizedLabel = (labelNode ? labelNode.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
        const normalizedHref = hrefValue.toLowerCase();

        if (normalizedLabel.includes('flashlight') || normalizedHref.includes('/collections/flashlights')) {
          groupedItems[0].push(item);
        } else if (normalizedLabel.includes('headlamp') || normalizedHref.includes('/collections/headlamps')) {
          groupedItems[1].push(item);
        } else if (normalizedLabel.includes('lantern') || normalizedHref.includes('/collections/lanterns')) {
          groupedItems[2].push(item);
        } else {
          otherItems.push(item);
        }
      });

      [...groupedItems[0], ...groupedItems[1], ...groupedItems[2], ...otherItems].forEach((item) => {
        drawerList.appendChild(item);
      });

      drawerList.dataset.primarySorted = 'true';
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
